import { useQuery } from "@apollo/client/react";
import { useCallback } from "react";

import { BillingTierFeature, SearchVcsIntegrationsOutput, VcsProvider } from "types/generated";
import useTierFeature from "views/Account/hooks/useTierFeature";

import { GET_DEFAULT_VCS_INTEGRATIONS } from "./gql";

const useGetDefaultVcsIntegration = () => {
  const isMultiVCSFeatureEnabled = useTierFeature(BillingTierFeature.MultipleVcs);

  const { data, loading, refetch } = useQuery<{
    searchVCSIntegrations: SearchVcsIntegrationsOutput;
  }>(GET_DEFAULT_VCS_INTEGRATIONS, {
    skip: isMultiVCSFeatureEnabled,
    fetchPolicy: "no-cache",
  });

  const refetchDefaultIntegrations = useCallback(() => {
    if (!isMultiVCSFeatureEnabled) {
      refetch();
    }
  }, [isMultiVCSFeatureEnabled, refetch]);

  return {
    loading,
    isSetupDisabled: (provider: VcsProvider) =>
      !isMultiVCSFeatureEnabled &&
      !!data?.searchVCSIntegrations.edges.find((edge) => edge.node?.provider === provider),
    refetchDefaultIntegrations,
  };
};

export default useGetDefaultVcsIntegration;
